import { getLocale } from '../../../common/utils/getLocale';
const locale = getLocale();
export const HELP_LINKS = {
  DELETE_MODAL: `https://support.wix.com/${locale ?? 'en'}/article/deleting-files-from-your-site`
};
//# sourceMappingURL=helpLinks.js.map